<template>
  <div>
    <v-sheet outlined class="pa-3 my-3" v-if="userBusinessInformation">
      <h4 class="blue--text mb-3">اطلاعات آدرس و تماس</h4>
      <v-row v-if="userBusinessInformation.address">
        <v-col cols="12" md="4" sm="6">
          <business-information-text-data
            label="استان:"
            :text="userBusinessInformation.address.stateName"
          />
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <business-information-text-data
            label="شهر:"
            :text="userBusinessInformation.address.cityName"
          />
        </v-col>

        <v-col cols="12" md="4" sm="6">
          <business-information-text-data
            label="شهرک صنعتی:"
            :text="
              !!userBusinessInformation.address.industrialParkName
                ? userBusinessInformation.address.industrialParkName
                : 'وارد نشده'
            "
          />
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <business-information-text-data
            label="پلاک:"
            :text="userBusinessInformation.address.no"
          />
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <business-information-text-data
            label="واحد:"
            :text="userBusinessInformation.address.unit"
          />
        </v-col>
        <v-col cols="12" md="4" sm="6">
          <business-information-text-data
            label="کد پستی:"
            :text="userBusinessInformation.address.postalCode"
          />
        </v-col>

        <v-col cols="12">
          <business-information-text-data
            label="اطلاعات تکمیلی آدرس:"
            :text="userBusinessInformation.address.addressLane"
          />
        </v-col>
        <v-col
          cols="12"
          md="4"
          v-for="(item, index) in userBusinessInformation.phones"
          :key="index"
        >
          <div class="mb-3">
            <business-information-text-data
              :label="' شماره ' + item.title + ':'"
              :text="item.phoneNumber"
            />
          </div>
        </v-col>
        <v-col cols="12" md="4" sm="6"></v-col>

        <v-col cols="12" v-if="merchantSocialMediaList.length">
          <business-information-text-data
            label="شبکه‌های اجتماعی:"
            :flex="false"
          >
            <ul>
              <li
                v-for="item in merchantSocialMediaList"
                :key="item.id"
                style="
                  display: flex;
                  justify-content: space-between;
                  margin-bottom: 0.5rem;
                "
              >
                <span>
                  {{ socialMediaDisplayName(item.socialMediaName) }}
                </span>
                <span class="blue--text">
                  {{ item.membershipId }}
                </span>
              </li>
            </ul>
          </business-information-text-data>
        </v-col>
        <v-col cols="12">
          <business-information-text-data
            label="وبسایت:"
            :text="userBusinessInformation.website"
            :link="true"
          />
        </v-col>

        <v-col
          cols="12"
          md="12"
          v-if="
            userBusinessInformation &&
            userBusinessInformation.address &&
            userBusinessInformation.address.latitude
          "
        >
          <v-btn
            class="float-left"
            color="error"
            icon
            @click="showMap = !showMap"
            v-if="showMap"
            ><v-icon>mdi-close</v-icon></v-btn
          >
          <v-btn
            class="float-left"
            @click="showMap = !showMap"
            color="primary"
            v-else
            >نمایش نقشه</v-btn
          >
          <l-map
            v-if="showMap"
            ref="myMap"
            :zoom="zoom"
            :center="center"
            style="width: 100%; height: 300px"
          >
            <l-tile-layer :url="url" />
            <l-marker
              v-for="(item, index) in marker"
              :key="index"
              :lat-lng="item"
            >
              <l-icon
                :icon-size="[40, 40]"
                :icon-anchor="[20, 40]"
                :icon-url="path"
              >
              </l-icon>
            </l-marker>
          </l-map>
          <v-btn
            @click="zoomPoint"
            id="refreshButton"
            color="primary"
            fab
            small
            dark
            v-if="showMap"
          >
            <v-icon>mdi-map-marker-question </v-icon>
          </v-btn>
        </v-col>
        <v-col cols="12" v-else>
          <h5>موقعیت جغرافیایی بر روی نقشه مشخص نشده است.</h5>
        </v-col>
      </v-row>
      <span v-else class="text--secondary">(وارد نشده)</span>
    </v-sheet>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { RepoFactory } from '@/baseRepository/Factory';
import Helper from '@/core/helpers';
const merchantRepository = () => RepoFactory.get('merchant');
import BusinessInformationTextData from './BusinessInformationTextData.vue';
import reusableMethodsMixin from '@/core/mixins/reusableMethodsMixin';
export default {
  mixins: [reusableMethodsMixin],
  components: {
    BusinessInformationTextData,
  },
  props: {
    userBusinessInformation: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      zoom: 5,
      path: '/media/map/pin.svg',
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      marker: [],
      center: [35.738018, 51.404314],
      merchantSocialMediaList: [],
      showMap: true,
    };
  },
  computed: {
    ...mapGetters(['merchantBaseUrl']),
  },
  created() {
    if (
      this.userBusinessInformation &&
      this.userBusinessInformation.address?.latitude
    ) {
      this.zoom = 6;
      this.marker.push({
        lat: this.userBusinessInformation.address.latitude,
        lng: this.userBusinessInformation.address.longitude,
      });
      this.center = [
        this.userBusinessInformation.address.latitude,
        this.userBusinessInformation.address.longitude,
      ];
    }
    if (this.userBusinessInformation && this.userBusinessInformation.merchantId)
      this.getMerchantSocialMediaList();
  },
  watch: {
    userBusinessInformation(after) {
      if (after && after.address?.latitude) {
        this.zoom = 6;
        this.marker.push({
          lat: after.address.latitude,
          lng: after.address.longitude,
        });
        this.center = [after.address.latitude, after.address.longitude];
      }
      if (after && after.merchantId) {
        this.getMerchantSocialMediaList();
      }
    },
  },
  methods: {
    zoomPoint() {
      this.$refs.myMap.mapObject.flyTo(this.marker[0], 15);
    },
    getMerchantSocialMediaList() {
      const loader = this.$loading.show();
      merchantRepository()
        .getMerchantSocialMediaList(
          this.userBusinessInformation.merchantId,
          this.merchantBaseUrl
        )
        .then(({ data }) => {
          this.merchantSocialMediaList = data;
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        })
        .finally(() => {
          loader.hide();
        });
    },
  },
};
</script>

<style></style>
